export default __webpack_public_path__ + "static/media/2x-google-play.33305bab.svg";